import keyMirror from 'keymirror';

export const solutionStatus = keyMirror({
  ACC: null,
  PAC: null,
  REJ: null,
  NRE: null,
  UNE: null,
  CLR: null,
  SUBMITTED: null,
});

export const solutionStatusLabel = {
  [solutionStatus.ACC]: 'Accepted',
  [solutionStatus.PAC]: 'Partially Accepted',
  [solutionStatus.REJ]: 'Rejected',
  [solutionStatus.NRE]: 'Needs Review',
  [solutionStatus.UNE]: 'UNE',
  [solutionStatus.SUBMITTED]: 'SUBMITTED',
  submitted: 'Submitted',
  expired: 'Deadline expired',
  unsolved: 'Unsolved',
  attempted: 'Attempted',
};
